import {mapActions, mapGetters} from "vuex";
import SessionTimeoutModal from "../components/modals/SessionTimeoutModal";
import config from "../config/app"

export default {
  components: {
    SessionTimeoutModal
  },
  data(){
    return {
      secondsToSessionEnd: null,
      sessionSecondsEndInterval: null
    }
  },
  computed: {
    ...mapGetters({
      sessionEndDate: 'sessionEndDate',
      isSessionUpdatePending: 'isSessionUpdatePending'
    })
  },
  watch: {
    sessionEndDate(){
      this.sessionSecondsEndInterval = setInterval(() => {
        this.secondsToSessionEnd = moment(this.sessionEndDate).diff(moment().format()) / 1000
      }, 1000);
    },
    secondsToSessionEnd(nextValue){
      if ( this.isSessionUpdatePending ){
        return
      }

      // logout user when session time is over
      if ( nextValue < 1 ){
        return this.lockUser();
      }

      // show "keep me logged in" modal when session time is less than (value from config)
      if (nextValue <= config.sessionSecondsLeftToShowModal){
        $('#session-timeout-dialog').modal('show')
        clearInterval(this.sessionSecondsEndInterval)
      }
    }
  },
  methods: {
    ...mapActions([
      'lockUser'
    ])
  }
}



// WEBPACK FOOTER //
// ./src/mixins/sessionEndHandler.js